import axios from 'axios';
import { getServerError } from '../error/error-service';
import { IApiUserAccount, IApiGetWorkerListParams, UserName } from './user-service.types';
import { IApiPagingParams, IApiPageRowsProperty } from '../paging/paging-service.types';

const TapApiApiBaseUrl = `/mes/api`;

export const getWorkerList = (params: IApiGetWorkerListParams): Promise<IApiUserAccount[]> => {
    return axios.get<{ workers: IApiUserAccount[] }>(`${TapApiApiBaseUrl}/worker`, { params })
        .then((response) => {
            return response.data.workers;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}
// для пейдженга на странице - /mes/input-data/executors
export const getWorkerList2 = (params: IApiPagingParams<IApiGetWorkerListParams>) => {
    return axios.get<IApiPageRowsProperty<IApiUserAccount, 'workers'>>(`${TapApiApiBaseUrl}/worker`, { params })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const getUserFIO = (user: UserName): string => {
    const parts = [];

    if (user.lastName) {
        parts.push(user.lastName + ' ');
    }

    if (user.firstName) {
        parts.push(user.firstName[0] + '.');
    }

    if (user.secondName) {
        parts.push(user.secondName[0] + '.');
    }

    return parts.join('').trim();
}

export const getUserFullName = (user: UserName): string => {
    const parts = [];

    if (user.lastName) {
        parts.push(user.lastName);
    }

    if (user.firstName) {
        parts.push(user.firstName);
    }

    if (user.secondName) {
        parts.push(user.secondName);
    }

    return parts.join(' ');
}